import React from 'react';
import './footer-contact.scss';

const Footer = () => {
  return (
    <div>
      <div className="mod-footer-contact">
        <div className="help-header">
          <hr />
          <span>Need Support?</span>
        </div>
        <div className="contact-row-items">
          <div className="contact-item">
            <div className="help-pod">
              <a href="/help">
                <img
                  src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/images/faq-icon.svg"
                  alt="FAQs"
                />
                <h3>FAQs</h3>
                <span className="text-content">Need help?</span>
              </a>
            </div>
            <hr className="item-separator" />
          </div>
          <div className="contact-item chat-container">
            <div className="chat-pod">
              <a href="javascript:void(0);" id="olark-chat-pod-anchor">
                <img
                  src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/images/chat-icon.svg"
                  alt="Live Chat"
                />
                <h3>Live Chat</h3>
                <span className="text-content">Chat with one of our customer support team members now </span>
              </a>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-pod">
              <a href="http://www2.dollargeneral.com/Ads-and-Promos/Coupons/Pages/DGDCTechnicalFeedback.aspx">
                <img
                  src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/images/contactus-icon.svg"
                  alt="Contact Us"
                />
                <h3>Contact us</h3>
                <span className="text-content">For additional questions on DG Digital Coupons </span>
              </a>
            </div>
            <hr className="item-separator" />
          </div>
        </div>
      </div>
      <footer id="ci-footer">
        <div className="mod mod-footer experiencefragment aem-GridColumn aem-GridColumn--default--12">
          <div className="cmp-experiencefragment">
            <div className="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
              <footer className="aem-footer aem-GridColumn aem-GridColumn--default--12">
                <div className="aem-footer-navigation">
                  <nav className="navigation__menu-wrapper" aria-label="Footer Navigation Menu">
                    <ul className="navigation__menu-list">
                      <li className="navigation-menu">
                        <button
                          type="button"
                          className="navigation-menu__toggle"
                          onClick={() => {
                            location.href = 'https://prod.dollargeneral.com/customer-support/store-support.html';
                          }}
                        >
                          Help
                        </button>
                      </li>
                      <li className="navigation-menu">
                        <button
                          type="button"
                          className="navigation-menu__toggle"
                          onClick={() => {
                            location.href = 'https://aboutus.dollargeneral.com/';
                          }}
                        >
                          Corporate
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div className="aem-footer__images">
                  <div className="image">
                    <div
                      data-cmp-lazy=""
                      data-cmp-src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/literacy-foundation-logo.png"
                      data-cmp-widths="300,400,500,600,700,800,900,1000,1100,1200"
                      data-asset="/content/dam/footer-images/lf.png"
                      className="cmp-image"
                      itemScope
                      itemType="http://schema.org/ImageObject"
                    >
                      <a
                        href="https://www.dgliteracy.org/"
                        className="cmp-image__wrapper cmp-image__wrapper--link"
                        data-cmp-hook-image="link"
                      >
                        <svg className="cmp-image__pinch" viewBox="0 0 190 145">
                          <path
                            transform="translate(-699.000000, -557.000000)"
                            d="M795.815287,694.255481 C776.459723,694.255481 725.002248,697 725.002248,697 C713.419304,696.974543 704.037036,689.938407 704,681.249578 L704,577.750422 C704.03708,569.056672 713.429581,562.018512 725.019108,562 C725.019108,562 776.465343,564.744519 795.832147,564.744519 C815.198951,564.744519 863.003372,562 863.003372,562 C874.585397,562.025468 883.966048,569.062275 884,577.750422 L884,681.249578 C883.966006,689.942646 874.575121,696.981477 862.986512,697 C862.986512,697 815.170851,694.255481 795.815287,694.255481 Z"
                          ></path>
                        </svg>
                        <svg className="cmp-image__square-pinch" viewBox="0 0 244 244">
                          <path d="M211.266276,8.94087452 C218.014803,8.46211952 224.318502,10.7640697 229.054758,14.8728405 C233.791013,18.9816115 236.959826,24.8972032 237.43858,31.6457311 C237.479514,32.2227327 237.5,32.801003 237.5,33.3794548 L237.5,33.3794548 L237.5,210.842705 C237.5,217.608193 234.757744,223.733193 230.324116,228.166821 C225.890488,232.600449 219.765488,235.342705 213,235.342705 C212.473693,235.342705 211.947523,235.325746 211.422308,235.291854 C168.487398,232.521286 138.679891,231.141963 122,231.141963 C105.320109,231.141963 75.5126022,232.521286 32.5776924,235.291854 C25.8262462,235.727522 19.5373696,233.385381 14.8274378,229.246462 C10.1175057,225.107542 6.98651845,219.171843 6.55085095,212.420397 C6.51695912,211.895182 6.5,211.369012 6.5,210.842705 L6.5,210.842705 L6.5,33.3794556 C6.49999944,26.6139672 9.24225512,20.4889671 13.675883,16.055339 C18.1095111,11.6217107 24.2345114,8.87945469 31,8.87945469 C31.5784517,8.87945469 32.156722,8.89994079 32.7337236,8.94087448 C75.645352,11.9851144 105.400873,13.5 122,13.5 L122.501921,13.4995455 C139.195553,13.4695494 168.783764,11.954672 211.266276,8.94087452 Z"></path>
                        </svg>
                        <img
                          className="cmp-image__image"
                          itemProp="contentUrl"
                          data-cmp-hook-image="image"
                          alt=""
                          src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/literacy-foundation-logo.png"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="image">
                    <div
                      data-cmp-lazy=""
                      data-cmp-src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/western-uninon-logo-blackbox-rgb.png"
                      data-cmp-widths="300,400,500,600,700,800,900,1000,1100,1200"
                      data-asset="/content/dam/footer-images/WU_Logo_BlackBox_RGB.png"
                      className="cmp-image"
                      itemScope
                      itemType="http://schema.org/ImageObject"
                    >
                      <a
                        href="https://www.dollargeneral.com/westernunion"
                        className="cmp-image__wrapper cmp-image__wrapper--link"
                        data-cmp-hook-image="link"
                      >
                        <svg className="cmp-image__pinch" viewBox="0 0 190 145">
                          <path
                            transform="translate(-699.000000, -557.000000)"
                            d="M795.815287,694.255481 C776.459723,694.255481 725.002248,697 725.002248,697 C713.419304,696.974543 704.037036,689.938407 704,681.249578 L704,577.750422 C704.03708,569.056672 713.429581,562.018512 725.019108,562 C725.019108,562 776.465343,564.744519 795.832147,564.744519 C815.198951,564.744519 863.003372,562 863.003372,562 C874.585397,562.025468 883.966048,569.062275 884,577.750422 L884,681.249578 C883.966006,689.942646 874.575121,696.981477 862.986512,697 C862.986512,697 815.170851,694.255481 795.815287,694.255481 Z"
                          ></path>
                        </svg>
                        <svg className="cmp-image__square-pinch" viewBox="0 0 244 244">
                          <path d="M211.266276,8.94087452 C218.014803,8.46211952 224.318502,10.7640697 229.054758,14.8728405 C233.791013,18.9816115 236.959826,24.8972032 237.43858,31.6457311 C237.479514,32.2227327 237.5,32.801003 237.5,33.3794548 L237.5,33.3794548 L237.5,210.842705 C237.5,217.608193 234.757744,223.733193 230.324116,228.166821 C225.890488,232.600449 219.765488,235.342705 213,235.342705 C212.473693,235.342705 211.947523,235.325746 211.422308,235.291854 C168.487398,232.521286 138.679891,231.141963 122,231.141963 C105.320109,231.141963 75.5126022,232.521286 32.5776924,235.291854 C25.8262462,235.727522 19.5373696,233.385381 14.8274378,229.246462 C10.1175057,225.107542 6.98651845,219.171843 6.55085095,212.420397 C6.51695912,211.895182 6.5,211.369012 6.5,210.842705 L6.5,210.842705 L6.5,33.3794556 C6.49999944,26.6139672 9.24225512,20.4889671 13.675883,16.055339 C18.1095111,11.6217107 24.2345114,8.87945469 31,8.87945469 C31.5784517,8.87945469 32.156722,8.89994079 32.7337236,8.94087448 C75.645352,11.9851144 105.400873,13.5 122,13.5 L122.501921,13.4995455 C139.195553,13.4695494 168.783764,11.954672 211.266276,8.94087452 Z"></path>
                        </svg>
                        <img
                          className="cmp-image__image"
                          itemProp="contentUrl"
                          data-cmp-hook-image="image"
                          alt=""
                          src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/western-uninon-logo-blackbox-rgb.png"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="image">
                    <div
                      data-cmp-lazy=""
                      data-cmp-src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/careers.png"
                      data-cmp-widths="300,400,500,600,700,800,900,1000,1100,1200"
                      data-asset="/content/dam/footer-images/careers.png"
                      className="cmp-image"
                      itemScope
                      itemType="http://schema.org/ImageObject"
                    >
                      <a
                        href="https://careers.dollargeneral.com/"
                        className="cmp-image__wrapper cmp-image__wrapper--link"
                        data-cmp-hook-image="link"
                      >
                        <svg className="cmp-image__pinch" viewBox="0 0 190 145">
                          <path
                            transform="translate(-699.000000, -557.000000)"
                            d="M795.815287,694.255481 C776.459723,694.255481 725.002248,697 725.002248,697 C713.419304,696.974543 704.037036,689.938407 704,681.249578 L704,577.750422 C704.03708,569.056672 713.429581,562.018512 725.019108,562 C725.019108,562 776.465343,564.744519 795.832147,564.744519 C815.198951,564.744519 863.003372,562 863.003372,562 C874.585397,562.025468 883.966048,569.062275 884,577.750422 L884,681.249578 C883.966006,689.942646 874.575121,696.981477 862.986512,697 C862.986512,697 815.170851,694.255481 795.815287,694.255481 Z"
                          ></path>
                        </svg>
                        <svg className="cmp-image__square-pinch" viewBox="0 0 244 244">
                          <path d="M211.266276,8.94087452 C218.014803,8.46211952 224.318502,10.7640697 229.054758,14.8728405 C233.791013,18.9816115 236.959826,24.8972032 237.43858,31.6457311 C237.479514,32.2227327 237.5,32.801003 237.5,33.3794548 L237.5,33.3794548 L237.5,210.842705 C237.5,217.608193 234.757744,223.733193 230.324116,228.166821 C225.890488,232.600449 219.765488,235.342705 213,235.342705 C212.473693,235.342705 211.947523,235.325746 211.422308,235.291854 C168.487398,232.521286 138.679891,231.141963 122,231.141963 C105.320109,231.141963 75.5126022,232.521286 32.5776924,235.291854 C25.8262462,235.727522 19.5373696,233.385381 14.8274378,229.246462 C10.1175057,225.107542 6.98651845,219.171843 6.55085095,212.420397 C6.51695912,211.895182 6.5,211.369012 6.5,210.842705 L6.5,210.842705 L6.5,33.3794556 C6.49999944,26.6139672 9.24225512,20.4889671 13.675883,16.055339 C18.1095111,11.6217107 24.2345114,8.87945469 31,8.87945469 C31.5784517,8.87945469 32.156722,8.89994079 32.7337236,8.94087448 C75.645352,11.9851144 105.400873,13.5 122,13.5 L122.501921,13.4995455 C139.195553,13.4695494 168.783764,11.954672 211.266276,8.94087452 Z"></path>
                        </svg>
                        <img
                          className="cmp-image__image"
                          itemProp="contentUrl"
                          data-cmp-hook-image="image"
                          alt=""
                          src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/careers.png"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="aem-footer-social-media">
                  <ul className="cmp-social">
                    <li className="cmp-social__item">
                      <a href="https://www.facebook.com/dollargeneral/" title="Dollar General Facebook">
                        <span className="dg-icon dg-icon-facebook"></span>
                      </a>
                    </li>
                    <li className="cmp-social__item">
                      <a
                        href="https://twitter.com/DollarGeneral?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
                        title="Dollar General Twitter"
                      >
                        <span className="dg-icon dg-icon-twitter"></span>
                      </a>
                    </li>
                    <li className="cmp-social__item">
                      <a href="https://www.instagram.com/dollargeneral/?hl=en" title="Dollar General Instagram">
                        <span className="dg-icon dg-icon-instagram"></span>
                      </a>
                    </li>
                    <li className="cmp-social__item">
                      <a href="https://www.pinterest.com/mydollargeneral/" title="Dollar General Pinterest">
                        <span className="dg-icon dg-icon-pinterest"></span>
                      </a>
                    </li>
                    <li className="cmp-social__item">
                      <a href="https://www.linkedin.com/company/dollar-general/" title="Dollar General Linkedln">
                        <span className="dg-icon dg-icon-linkedin"></span>
                      </a>
                    </li>
                    <li className="cmp-social__item">
                      <a href="https://www.youtube.com/user/DOLLARGENERAL" title="Dollar General YouTube">
                        <span className="dg-icon dg-icon-youtube"></span>
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="aem-footer__text-block">
                  <div className="cmp-text">
                    <p style={{ textAlign: 'center' }}>
                      <sup>
                        <span className="cmp-text--light-grey">
                          <a href="https://www.dollargeneral.com/privacy-policy">Privacy</a> |
                          <a href="https://www.dollargeneral.com/terms-and-conditions">Terms</a>
                          <br />
                          <a href="http://www2.dollargeneral.com/Customer-Care-Center/Documents/CaliforniaTransparencyPostingDocument.pdf?_ga=2.226146714.189576440.1602535877-1789249090.1591732072">
                            California Privacy Rights&nbsp;
                          </a>
                          |&nbsp;
                          <a href="https://dg.clarip.com/dsr/create">Do Not Sell My Info&nbsp;</a>|&nbsp;
                          <a href="https://www.dollargeneral.com/accessibility-statement">Accessibility Statement</a>
                          <br />
                          <br />
                          <a href="https://www.essentialaccessibility.com/dollar-general/?utm_source=dollargeneralhomepage&amp;utm_medium=iconlarge&amp;utm_term=eachannelpage&amp;utm_content=header&amp;utm_campaign=dollargeneral">
                            <img
                              src="https://sb.monetate.net/img/1/553/2594999.png"
                              alt="DG Accessibility Statement Icon"
                            />
                          </a>
                        </span>
                      </sup>
                    </p>
                    <p style={{ textAlign: 'center' }}>
                      <span className="cmp-text--light-grey">
                        <sup>
                          <sub>
                            Product availability, styles, colors, brands, promotions and prices may vary between stores
                            and online. <br />
                            Early sell-out possible on special purchase items, and quantities may be otherwise limited.
                            We reserve the <br />
                            right in our sole discretion to limit quantities to normal retail and online purchases. No
                            rain checks available. <br />
                            Not responsible for typographical errors.
                          </sub>
                        </sup>
                      </span>
                    </p>
                    <p style={{ textAlign: 'center' }}>&nbsp;</p>
                  </div>
                </div>
                <div className="aem-footer__text-block aem-footer__text-block--copyright">
                  © Copyright {new Date().getFullYear()}. Dollar General Corporation.
                  <br />
                  All rights reserved.
                </div>
              </footer>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
